<template>
    <section class="section_music">
        <h2 class="section--title text-center"><strong>Music</strong></h2>

        <div class="section_music--main">
            <div class="grid-container">
                <div class="grid-x grid-padding-x align-center">
                    <section class="cell small-12 medium-10">
                        <ul class="grid-x grid-padding-x">
                            <li class="cell small-12 large-6">
                                <article class="novel_article grid-x grid-padding-x">
                                    <figure class="novel_article--image cell small-12 medium-4 small-order-2 medium-order-1">
                                        <img :src="item.image" :alt="item.nameKanji">
                                    </figure>
                                    <section class="cell small-12 medium-8 small-order-1 medium-order-2">
                                        <h3 class="novel_article--title lowercase" v-html="item.name"></h3>
                                    </section>
                                    <div class="cell small-12 small-order-3 medium-order-3">
                                        <p class="novel_article--content" v-html="item.description"></p>
                                    </div>
                                </article>
                            </li>
                            <li class="comment_article--holder cell small-12 large-6">
                                <section class="comment_article">
                                    <h3 class="comment_article--title"><img src="/netemosametemo/static/img/comment.png" alt="Comment"><strong class="seo">Comment</strong></h3>
                                    <p class="comment_article--content" v-html="item.comment"></p>
                                </section>
                            </li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'music',
    data () {
        return {
            item: {
                nameKanji: 'tofubeats',
                name: 'tofubeats<strong><span>音楽：</span>tofubeats</strong>',
                description: '1990年11月26日、兵庫県生まれ。<br>中学時代から活動を開始し、高校3年生の時に国内最大のテクノイベントWIREに史上最年少で出演。その後も、「水星 feat.オノマトペ大臣」（12）がiTunes Storeシングル総合チャートで１位を獲得、森高千里、の子（神聖かまってちゃん）、藤井隆ら人気アーティストと数々のコラボを行い注目を集める。これまでにインディーズ含め4枚のアルバムをリリース。「電影少女 -VIDEO GIRL AI 2018-」（18/TX）でテレビドラマの主題歌・劇伴を担当するなど、活躍の場を広げている。濱口竜介監督の前作『ハッピーアワー』（15）に深く感銘を受けたことが縁で本作『寝ても覚めても』で初めて映画音楽に挑戦。主題歌「RIVER」も書き下ろしている。',
                comment: 'この度は初の映画音楽、そして主題歌を濱口監督の映画で務めさせていただくことになり、嬉しさと不安の入り混じった気持ちで制作期間を過ごしました。朝子と亮平の物語に寄り添えるものになるよう、書いてみたつもりです。試写でも拝見させていただきましたが、鑑賞後の独特な気分はこの映画でしか味わえないものだと思います。みなさまも是非。',
                image: '/netemosametemo/static/img/tofubeats_img.jpg'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Music.vue